// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1a4gL","rootSuccess":"CompleteLink_rootSuccess__VJcr2","rootFailure":"CompleteLink_rootFailure__3Fyzs","isDisabled":"CompleteLink_isDisabled__2KY0y"};